import styled, { css } from 'styled-components';

import { Typography } from '@/components/ui/Typography/Typography.styles';
import { flexColumn } from '@/styles/common';

export const Wrapper = styled.div`
  ${flexColumn}
`;

export const CategoryWrapper = styled.div`
  cursor: pointer;
  ${flexColumn}
`;

export const CategoryHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  cursor: pointer;
`;

export const CategoryLabel = styled(Typography)`
  flex: 1;
`;

export const Arrow = styled.div<{
  $isOpen: boolean;
}>`
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.3s ease;

  svg {
    height: 7px;
    width: 12px;
  }
`;

export const JobsWrapper = styled.div<{ $isOpen: boolean }>`
  ${flexColumn}
  padding-left: 20px;
  overflow: hidden;
  transition: all 0.3s ease;

  ${({ $isOpen }) =>
    $isOpen
      ? css`
          max-height: fit-content;
          opacity: 1;
          transform: translateY(0);
        `
      : css`
          max-height: 0;
          opacity: 0;
          transform: translateY(-20px);
        `}
`;

export const JobItem = styled.label`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
`;

export const JobLabel = styled(Typography).attrs({ variant: 'body3' })`
  color: var(--textAndLabels-secondary);
`;
